import React from "react";
import { testimonials } from "../mock";
import { Star, Quote } from "lucide-react";

const Testimonials = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="font-display text-center text-4xl md:text-5xl font-bold">
          TESTI<span className="text-[color:var(--brand-red)]">MONIALS</span>
        </h2>
        <div className="h-1 w-20 bg-[color:var(--brand-red)] mx-auto mt-4 mb-14" />

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-md p-8 shadow-sm border border-gray-100 hover:border-[color:var(--brand-red)]/40 transition-colors"
            >
              <Quote className="text-[color:var(--brand-red)] mb-4" size={28} />
              <p className="text-gray-700 leading-relaxed italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[color:var(--brand-teal)] text-white flex items-center justify-center font-display font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-gray-800">{t.name}</div>
                  <div className="flex gap-0.5 mt-0.5">
                    {Array.from({ length: t.rating }).map((_, k) => (
                      <Star key={k} size={14} className="fill-[color:var(--brand-red)] text-[color:var(--brand-red)]" />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
